import { render, staticRenderFns } from "./MyMembershipInfo.vue?vue&type=template&id=20a9b68a"
import script from "./MyMembershipInfo.vue?vue&type=script&lang=ts"
export * from "./MyMembershipInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports